import React, { Suspense, lazy, useEffect, useState } from 'react';
import logo from './images/logo.png';
import backgroundImage from './images/krajina.jpg';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import './App.css';

const EventDetail = lazy(() => import('./pages/EventDetail'));
const Faq = lazy(() => import('./pages/Faq'));
const Gdpr = lazy(() => import('./pages/Gdpr'));
const Home = lazy(() => import('./pages/Home'));
const Gallery = lazy(() => import('./pages/Gallery'));
const NotFound = lazy(() => import('./pages/NotFound'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const EventsList = lazy(() => import('./pages/EventsList'));
const Submission = lazy(() => import('./pages/Submission'));
const Success = lazy(() => import('./pages/Success'));
const SuperEventsList = lazy(() => import('./pages/SuperEventsList'));
const Covid = lazy(() => import('./pages/Covid'));
const SendReview = lazy(() => import ('./pages/SendReview'));
const ReviewSent = lazy(() => import('./pages/ReviewSent'));

const styles = {
  container: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundPosition: 'bottom center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed'
  }
};

function App() {

  const [activeMenu, setActiveMenu] = useState(false);

  useEffect(() => {
    document.title = 'Karamela | Dětské tábory a akce'
  }, []);

  function handleMenuExpand(event) {
    event.preventDefault();
    let res = event.target.classList.toggle('is-active');
    setActiveMenu(res);
  };

  return (
    <div style={styles.container}>
      {/* <div className="pagelabel">
        <a>2021</a>
      </div> */}
      <Router>
        <section className='section'>
          <nav className='navbar is-primary' role='navigation' aria-label='main navigation'>
            <div className='navbar-brand'>
              <Link to={`/`} className='navbar-item'>
                <img src={logo} alt='Logo Karamela' />
              </Link>

              <p onClick={handleMenuExpand} role='button' className='navbar-burger burger' data-target='navMenu' aria-label='menu' aria-expanded='false'>
                <span aria-hidden='true'></span>
                <span aria-hidden='true'></span>
                <span aria-hidden='true'></span>
              </p>
            </div>

            {activeMenu &&
              <div id='navMenu' className='navbar-menu is-active'>
                <div className='navbar-end'>
                  <div className='navbar-item'>
                    <div className='field is-grouped is-grouped-multiline social'>
                      <p className='control'>
                        <Link to={`/`} className='button is-primary'>
                          <span>Hlavní stránka</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/about`} className='button is-primary'>
                          <span>Informace</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/gallery`} className='button is-primary'>
                          <span>Galerie</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/faq`} className='button is-primary'>
                          <span>Časté dotazy</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/contact`} className='button is-primary'>
                          <span>Kontakt</span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }

            {!activeMenu &&
              <div id='navMenu' className='navbar-menu'>
                <div className='navbar-end'>
                  <div className='navbar-item'>
                    <div className='field is-grouped is-grouped-multiline social'>
                      <p className='control'>
                        <Link to={`/`} className='button is-primary'>
                          <span>Hlavní stránka</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/about`} className='button is-primary'>
                          <span>Informace</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/gallery`} className='button is-primary'>
                          <span>Galerie</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/faq`} className='button is-primary'>
                          <span>Časté dotazy</span>
                        </Link>
                      </p>
                      <p className='control'>
                        <Link to={`/contact`} className='button is-primary'>
                          <span>Kontakt</span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </nav>
        </section>

        <div className='container main-wrapper'>
          <Suspense fallback={<p></p>}>
            <Switch>
              <Route exact path='/' component={Home} />
              <Route exact path='/super-events/:typeId' component={SuperEventsList} />
              <Route exact path='/events/event/:eventId' component={EventDetail} />
              <Route exact path='/events/:typeId/:superEventId' component={EventsList} />
              <Route exact path='/faq' component={Faq} />
              <Route exact path='/about' component={About} />
              <Route exact path='/contact' component={Contact} />
              <Route exact path='/gallery' component={Gallery} />
              <Route exact path='/success' component={Success} />
              <Route exact path='/submission/:eventId' component={Submission} />
              <Route exact path='/gdpr' component={Gdpr} />
              <Route exact path='/covid' component={Covid} />
              <Route exact path='/review' component={SendReview} />
              <Route exact path='/review-sent' component={ReviewSent} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </div>
      </Router>
    </div>
  );
}

export default App;
